
import { bootLoader } from '@xanadu/ui-shared';
import { deepMerge } from '@xanadu/ui-shared/utils/lodashAlternatives';

import { getClientEmail } from '../../../common/utils';
import bootApp from '../../../common/boot';

import brandConfig from '../../config';
import siteConfig from './config';

import { sagas } from '../../modules';

import '../../theme.scss';
import './theme.scss';
import { ZENDESK_WIDGET_TYPES } from '../../../common/constants';

const combinedConfig = deepMerge(brandConfig, siteConfig);

const {
  site,
  brand,
  domain,
  routes,
  modalContents,
  featuresFlags,
  customization,
  clientDefaultLanguage,
  clientDefaultCurrency,
  availableLanguages,
  availableCurrencies,
  availableOddsTypes,
  availableFeatures,
  fallbackReleaseDate,
  excludedSports,
  settings,
  enabledPrefixes,
  defaultProduct,
} = combinedConfig;

(async () => {
  const createApp = bootApp({
    site,
    brand,
    domain,
    routes,
    modalContents,
    featuresFlags,
    customization,
    ZENDESK_KEY: '73615461-7537-43dc-9d75-e41c57133100',
    ZENDESK_WIDGET_TYPE: ZENDESK_WIDGET_TYPES.new,
    clientDefaultLanguage,
    clientDefaultCurrency,
    availableLanguages,
    availableCurrencies,
    availableOddsTypes,
    availableFeatures,
    fallbackReleaseDate,
    excludedSports,
    settings,
    enabledPrefixes,
    clientSupportEmail: getClientEmail(brand, site),
    defaultProduct,
    // Here to add brand specific reducers and sagas
    sagas,
  });

  await bootLoader({
    brand,
    createApp,
    clientDefaultCurrency,
    clientDefaultLanguage,
    // eslint-disable-next-line no-undef
    cookieDomain: __COOKIE_DOMAIN__,
    availableCurrencies,
    availableOddsTypes,
    defaultProduct,
  });
})();
